import { render, staticRenderFns } from "./fhxsc.vue?vue&type=template&id=933fa602&"
import script from "./fhxsc.vue?vue&type=script&lang=js&"
export * from "./fhxsc.vue?vue&type=script&lang=js&"
import style0 from "./fhxsc.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports